import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { DccMarkupRateGridRow } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const DCC_MARKUP_RATE_GRID_DEFAULT_COL_DEF = {
  suppressAutoSize: true,
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const dccMarkupRateGridOptions = {
  ...commonGridOptions,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No DCC markup rates configured for this terminal yet.</span>',
} satisfies GridOptions<DccMarkupRateGridRow>;

export const dccMarkupRateSearchEmptyGridOptions = {
  ...commonGridOptions,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No rates match the current filters.</span>',
} satisfies GridOptions<DccMarkupRateGridRow>;
